import DefaultLogoIconRS from '@/assets/icons/icon-rs.svg';
import DefaultLogoIcon from '@/assets/icons/logo-color-icon.png';
import { Image } from '@/components';
import type { FC } from 'react';

type Props = {
  onClick?: () => void;
  hidden?: boolean;
};

export const LogoIcon: FC<Props> = ({ onClick, hidden }) => {
  return (
    <Image
      src={DefaultLogoIconRS}
      fallback={DefaultLogoIcon}
      alt="logo icon"
      style={{
        height: '43px',
        width: '43px',
        cursor: 'pointer',
        display: hidden ? 'none' : undefined,
      }}
      onClick={onClick}
      preview={false}
    />
  );
};
